<template>
  <el-table-column
    prop="company.name"
    label="Partner"
    show-overflow-tooltip
    min-width="180"
    sortable="custom"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.partner && scope.row.partner.company && scope.row.partner.company.name"> <strong>#{{ scope.row.partner.id }}</strong> {{ scope.row.partner.company.name }}</span>
      <el-tag type="danger" v-else size="small">Nincs partner</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'company.name',
  };
</script>
